import { SafeModeConfig } from './configuration';

const SAFE_MODE_FIREDRILL_OPTIMIZELY = 'f_safe_mode_firedrill';

export interface safeModeConfigType {
    [brand: string]: {
        GCP: SafeModeConfig;
        GCPFireDrill: SafeModeConfig;
    };
}

export const createSafeModeConfigurator = (
    safeModeConfig: safeModeConfigType,
    getBrandName: () => string,
) => {
    let config: SafeModeConfig | null = null;

    const getSafeModeConfig = () => {
        if (config === null) {
            throw new Error(
                '[Bootstrap] Bad init: feature flag is not read yet ',
            );
        }
        return config;
    };

    const readSafeModeFlag = (
        isEnabled: (experimentName: string) => boolean | null,
    ) => {
        const brand = getBrandName();
        const brandConfig = safeModeConfig[brand] || safeModeConfig.dazn;

        config =
            isEnabled(SAFE_MODE_FIREDRILL_OPTIMIZELY) ?? false
                ? brandConfig.GCPFireDrill
                : brandConfig.GCP;

        return config;
    };
    return {
        readSafeModeFlag,
        getSafeModeConfig,
    };
};
